var React = require('react');

function SidebarCircle01Inline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"8","height":"8","fill":"white","key":0}),React.createElement("path",{"d":"M2.8017 1.53164C4.82194 1.49991 5.29148 1.20676 6.45991 2.49991C7.26075 3.38622 7.22642 5.3984 6 6.49991C4.67236 7.69232 2.36885 6.58313 1.73403 6.05139C1.00001 5.43657 1 4.48174 1 3.65858C1.16667 3.10572 1.8 2 3 2","stroke":"#7F879D","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

SidebarCircle01Inline.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none"};

module.exports = SidebarCircle01Inline;

SidebarCircle01Inline.default = SidebarCircle01Inline;
